import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { motion } from 'framer-motion';
import { Lock, Clock, Zap } from 'lucide-react';
export function PriceSection() {
  const {
    minutes,
    seconds
  } = useCountdown(20);
  return <section id="precio" className="py-12 sm:py-16 lg:py-24 bg-white relative overflow-hidden" data-id="element-104">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-105">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-green-lighter/10 rounded-full blur-3xl" data-id="element-106"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-brand-accent-yellow/10 rounded-full blur-3xl" data-id="element-107"></div>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-108">
        <motion.div className="bg-brand-bg-cream rounded-[2.5rem] p-8 sm:p-12 shadow-2xl border-2 border-brand-green/20 text-center" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-109">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-brand-green/10 text-brand-green px-4 py-1.5 rounded-full text-sm font-semibold mb-6" data-id="element-110">
            <span data-id="element-111">COMENZÁ HOY</span>
          </div>

          <h2 className="text-3xl sm:text-4xl font-playfair font-bold text-brand-text-dark mb-2" data-id="element-112">
            Acceso inmediato con{' '}
            <span className="italic text-brand-green" data-id="element-113">descuento</span>
          </h2>
          <p className="text-brand-text-medium mb-8 font-inter" data-id="element-114">
            Empezá hoy mismo a transformar tu digestión
          </p>

          <div className="flex flex-col items-center justify-center mb-8" data-id="element-115">
            <span className="text-xl text-brand-text-medium line-through decoration-red-400 decoration-2 mb-2" data-id="element-116">
              Antes: $39.990
            </span>
            <div className="flex items-baseline gap-3" data-id="element-117">
              <span className="text-2xl font-bold text-brand-green" data-id="element-118">Hoy:</span>
              <span className="text-6xl sm:text-7xl font-poppins font-bold text-brand-green tracking-tight" data-id="element-119">
                $19.990
              </span>
            </div>
            <span className="mt-2 text-sm font-medium text-brand-accent-orange bg-brand-accent-orange/10 px-3 py-1 rounded-full" data-id="element-120">
              50% de descuento
            </span>
          </div>

          <div className="inline-flex items-center gap-2 bg-red-50 text-red-600 px-4 py-2 rounded-full font-medium mb-8" data-id="element-121">
            <Clock className="w-5 h-5 animate-pulse" data-id="element-122" />
            <span data-id="element-123">
              La oferta termina en: {minutes}:{seconds}
            </span>
          </div>

          <div className="block" data-id="element-124">
            <motion.a href="https://pago.atlasdigitalhub.com/cart/42725974540386:1" className="inline-block w-full sm:w-auto min-w-[280px] bg-brand-accent-orange hover:bg-[#c27622] text-white font-poppins font-bold text-xl py-5 px-10 rounded-full shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1 mb-6" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} data-id="element-125">
              QUIERO EL PLAN AHORA
            </motion.a>
          </div>

          <div className="flex items-center justify-center gap-2 text-brand-text-medium text-sm font-medium" data-id="element-126">
            <Lock className="w-4 h-4 text-green-600" data-id="element-127" />
            <span data-id="element-128">Pago 100% seguro y encriptado</span>
          </div>
        </motion.div>
      </div>
    </section>;
}